import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PromoteOwnerAppBanner } from '@awazevr/design-system.components.promote-owner-app-banner';

const BannerContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
`;

const PromoteOwnerAppBannerWrapper = ({ title, description, buttonText, ...rest }) => {
    if(navigator.userAgent.includes('awz-owner-wv')) {
        return <></>;
    }
    return (
        <BannerContainer>
            <PromoteOwnerAppBanner
                title={title}
                description={description}
                buttonText={buttonText}
                {...rest}
            />
        </BannerContainer>
    );
};

PromoteOwnerAppBannerWrapper.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
};

export default PromoteOwnerAppBannerWrapper;
